<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-button type="primary" @click="show_fixation" :disabled="!selectedRowKeys.length"> 固定资产采购入库 </a-button>
			<a-button type="primary" @click="show_flow" :disabled="!selectedRowKeys.length"> 流动资产采购入库 </a-button>
			<!-- <a-button type="primary"> 导出 </a-button> -->
		</div>
		<div class="content_main_top">
			<a-input class="a_select_self margin_self" v-model="serchInfo.purchaseCode" allowClear placeholder="申请单号" @keyup.enter.native="serch_get_lis"/>
			<a-input class="a_select_self margin_self" v-model="serchInfo.createBy" allowClear placeholder="申请人" @keyup.enter.native="serch_get_lis"/>
			<a-select show-search allowClear placeholder="公司名称" class="margin_self" @change="handlecompany" v-model="serchInfo.company_id" @keyup.enter.native="serch_get_lis"
			 style="width: 120px">
				<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select>
			<a-tree-select allowClear :treeData="deptTree" v-model="serchInfo.deptId" :disabled="!serchInfo.company_id" placeholder="部门名称" @keyup.enter.native="serch_get_lis"
			 class="margin_self" style="width: 120px" treeDefaultExpandAll>
			</a-tree-select>
			<!-- <a-select show-search allowClear v-model="serchInfo.deptId" :disabled="!serchInfo.company_id" placeholder="部门名称" @keyup.enter.native="serch_get_lis"
			 class="margin_self" style="width: 120px">
				<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select> -->
			<a-range-picker v-model="serchInfo.createTimelist" valueFormat="YYYY-MM-DD" :placeholder="['申请开始', '申请结束']" style="width: 230px; margin-right: 10px" @keyup.enter.native="serch_get_lis"/>
			<a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
			<a-button type="primary" @click="reset"> 重置 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :data-source="lis" bordered :loading="loading" :pagination="pagination" @change="handleTableChange" rowKey="goodsId"
			 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }" :scroll="{ x: 1500, y: scroll_y, scrollToFirstRowOnChange: true }">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}</template>
				</a-table-column>
				<a-table-column key="purchaseCode" width="140px" ellipsis="true" title="申请单号" data-index="purchaseCode" />
				<a-table-column key="deptName" width="140px" ellipsis="true" title="申请部门" data-index="deptName" />
				<a-table-column key="createBy" width="120px" ellipsis="true" title="申请人" data-index="createByName" />
				<a-table-column key="itemType" width="100px" ellipsis="true" title="物品类型" data-index="itemType">
					<template slot-scope="text">
						{{ text ?goodsTypeObj[text]:''}}
					</template>
				</a-table-column>
				<a-table-column key="applyName" width="100px" ellipsis="true" title="物品名称" data-index="applyName" />
				<a-table-column key="applyModel" width="100px" ellipsis="true" title="规格型号" data-index="applyModel" />
				<a-table-column key="actualAmount" width="100px" ellipsis="true" title="采购数量" data-index="actualAmount" />
				<a-table-column key="warehousingAmount" width="120px" ellipsis="true" title="待入库数量" data-index="warehousingAmount" />
				<a-table-column key="price" width="100px" ellipsis="true" title="预估单价" data-index="price" />
				<a-table-column key="createTime" width="120px" ellipsis="true" title="申请时间" data-index="createTime" />
				<a-table-column key="expectDate" width="120px" ellipsis="true" title="期望交付时间" data-index="expectDate" />
				<a-table-column key="arrivalDate" width="120px" ellipsis="true" title="到货日期" data-index="arrivalDate" />
				<a-table-column key="applyRemark" width="100px" ellipsis="true" title="备注" data-index="applyRemark" />
				<a-table-column key="purchasePrice" width="100px" ellipsis="true" title="采购总金额" data-index="purchasePrice" />
				<a-table-column key="supplier" width="100px" ellipsis="true" title="供应商" data-index="supplier" />
				<a-table-column key="purchaserName" width="100px" ellipsis="true" title="采购人" data-index="purchaserName" />
				<a-table-column key="purchaseTime" width="100px" ellipsis="true" title="采购时间" data-index="purchaseTime" />
				<!-- <a-table-column title="详情" width="100px">
          <template scope="text,record">
            <a @click="show_details(record)">详情</a>
          </template>
        </a-table-column> -->
			</a-table>
		</div>
		<!-- 固定资产录入 -->
		<a-modal title="固定资产采购入库" :visible="is_fixation" @cancel="is_fixation = false" width="60%" :maskClosable = "false">
			<template slot="footer">
				<a-button key="back" @click="is_fixation = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="sumbitFixation"> 确定 </a-button>
			</template>
			<a-form-model :model="form" ref="ruleFormFixation" :rules="rulesFixation" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="申请单号" prop="orderCode">
							<a-input v-model="form.orderCode" disabled placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="公司名称" prop="company_name">
							<a-input v-model="form.company_name" disabled></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="资产类别" prop="asset_type">
							<a-select placeholder="请选择" allowClear v-model="form.asset_type">
								<a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品编号" prop="asset_sn">
							<a-input v-model="form.asset_sn" placeholder="请输入" @input="setUploadInfo" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品名称" prop="name">
							<a-input v-model="form.name" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品单位" prop="unit">
							<a-input v-model="form.unit" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品状态" prop="state">
							<a-select v-model="form.state" placeholder="请选择" allowClear>
								<a-select-option :value="index" v-for="(item, index) in statusMap" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="规格型号" prop="model">
							<a-input v-model="form.model" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="存放位置" prop="storage_loc">
							<a-input v-model="form.storage_loc" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="作业条件" prop="storage_cond">
							<a-input v-model="form.storage_cond" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购时间" prop="purchase_time">
							<a-date-picker placeholder="请选择" style="width: 100%" valueFormat="YYYY-MM-DD" allowClear disabled v-model="form.purchase_time" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购总金额" prop="purchase_price">
							<a-input v-model="form.purchase_price" type="number" disabled placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="申请数量">
							<a-input v-model="form.amount" type="number" disabled placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购数量">
							<a-input v-model="form.actualAmount" type="number" disabled placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="待入库数量">
							<a-input v-model="form.warehousingAmount" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="入库数量">
							<span>1</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购单价">
							<a-input v-model="form.singlePrice" type="number" disabled placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="责任部门" prop="dept_id">
							<a-select allowClear v-model="form.dept_id" @change="setUploadInfo" placeholder="部门名称">
								<a-select-option :value="item.dept_id" v-for="(item, index) in formdeptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="当前估值" prop="value">
							<a-input v-model="form.value" type="number" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="责任人" prop="charger">
							<a-input v-model="form.charger" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="入库人" prop="operator">
							<a-input v-model="form.operator" placeholder="请输入" disabled allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="保管人" prop="keeper">
							<a-input v-model="form.keeper" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="到货日期" prop="arrive_time">
							<a-date-picker placeholder="请选择" style="width: 100%" valueFormat="YYYY-MM-DD" allowClear v-model="form.arrive_time" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="供应商" prop="dealer">
							<a-input v-model="form.dealer" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="生产厂家" prop="manufacturer">
							<a-input v-model="form.manufacturer" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出厂编号" prop="factory_sn">
							<a-input v-model="form.factory_sn" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否检定" prop="is_inspected">
							<a-select v-model="form.is_inspected" placeholder="请选择">
								<a-select-option value="1"> 是 </a-select-option>
								<a-select-option value="0"> 否 </a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定周期" prop="inspect_cycle">
							<a-input v-model="form.inspect_cycle" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定日期" prop="inspect_time">
							<a-date-picker style="width: 100%" placeholder="请选择" valueFormat="YYYY-MM-DD" allowClear v-model="form.inspect_time" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="仪器精度" prop="precisions">
							<a-input v-model="form.precisions" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定结果" prop="inspect_result">
							<a-input v-model="form.inspect_result" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="准用说明">
							<a-input v-model="form.permit" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="备注信息" prop="notes">
							<a-input v-model="form.notes" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件信息">
							<upload-img v-if="form.asset_sn && form.dept_id" :data="fileData" @ok="handleOk" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<!-- 流动录入 -->
		<a-modal title="流动资产采购入库" :visible="is_flow" @cancel="is_flow = false" width="70%" :maskClosable = "false">
			<template slot="footer">
				<a-button key="back" @click="is_flow = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="sumbitFLow"> 确定 </a-button>
			</template>
			<a-form-model :model="formFlow" :rules="rulesFlow" ref="ruleFormFlow" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="申请单号" prop="orderCode">
							<a-input v-model="formFlow.orderCode" disabled placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="公司名称" prop="company_name">
							<a-input v-model="formFlow.company_name" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="资产类别" prop="asset_type">
							<a-select placeholder="请选择" allowClear v-model="formFlow.asset_type">
								<a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="物品名称" prop="name">
							<a-input v-model="formFlow.name" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="选择品类" prop="cateModule">
							<a-input v-model="formFlow.cateModule" @click="show_all" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="规格型号" prop="model">
							<a-input v-model="formFlow.model" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="物品单位" prop="unit">
							<a-input v-model="formFlow.unit" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="物品状态">
							<a-select v-model="formFlow.state" placeholder="请选择" allowClear>
								<a-select-option :value="index" v-for="(item, index) in statusMap" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="采购单价" prop="purchase_price">
							<a-input disabled v-model="formFlow.purchase_price" type="number" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="保管人">
							<a-input v-model="formFlow.keeper" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="责任部门" prop="dept_id">
							<a-select allowClear v-model="formFlow.dept_id" @change="setUploadInfoFlow($event)" placeholder="部门名称">
								<a-select-option :value="item.dept_id" v-for="(item, index) in formdeptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="责任人" prop="charger">
							<a-input v-model="formFlow.charger" placeholder="请选择" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="采购时间" prop="purchase_time">
							<a-input v-model="formFlow.purchase_time" placeholder="请选择" disabled allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="采购总额">
							<a-input v-model="formFlow.value" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="采购数量">
							<a-input v-model="formFlow.purchase_amount" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="申请数量">
							<a-input v-model="formFlow.amountPlase" disabled></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="待入库数量">
							<a-input v-model="formFlow.warehousingAmount" disabled></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="入库数量" prop="amount">
							<a-input v-model="formFlow.amount" type="number" placeholder="入库数量不能小于0或大于待入库数量" @change="amountchange(formFlow.amount)"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="供应商">
							<a-input v-model="formFlow.dealer"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="生产厂家">
							<a-input v-model="formFlow.manufacturer"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="定值">
							<a-input v-model="formFlow.stable_lmt" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="生产批号">
							<a-input v-model="formFlow.factory_batch" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="存放位置">
							<a-input v-model="form.storage_loc" placeholder="请输入" allowClear></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="是否检定" prop="is_inspected">
							<a-select v-model="formFlow.is_inspected" placeholder="请选择">
								<a-select-option value="1"> 是 </a-select-option>
								<a-select-option value="0"> 否 </a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="到货时间">
							<a-date-picker style="width: 100%" placeholder="请选择" valueFormat="YYYY-MM-DD" allowClear v-model="formFlow.arrive_time" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="检定周期">
							<a-input v-model="formFlow.inspect_cycle"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="检定日期">
							<a-date-picker style="width: 100%" placeholder="请选择" valueFormat="YYYY-MM-DD" allowClear v-model="formFlow.inspect_time" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="检定结果">
							<a-input v-model="formFlow.inspect_result"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="备注">
							<a-input v-model="formFlow.notes"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="易制毒、易制爆" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-checkbox-group disabled v-model="formFlow.hazard_type" :options="plainOptions" />
							<a-input v-if="formFlow.hazard_type.indexOf('其他') != -1" disabled placeholder="请输入" style="width: 160px; margin-left: 15px"
							 v-model="formFlow.hazard_type_other"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="存放条件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-checkbox-group disabled v-model="formFlow.storage_cond" :options="plainOptions2" />
							<a-input v-if="formFlow.storage_cond.indexOf('其他') != -1" disabled placeholder="请输入" style="width: 160px; margin-left: 15px"
							 v-model="formFlow.storage_cond_other"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="上传附件">
							<upload-img v-if="formFlow.dept_id" :data="fileDataFlow" @ok="handleOkFlow" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<!-- 物品弹框 -->
		<a-modal title="请选择物品" v-model="changevisible" width="70%">
			<template slot="footer">
				<a-button key="back" @click="changevisible = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="selectRadioFlow"> 确定 </a-button>
			</template>
			<a-row>
				<a-input v-model="goodInfo.id" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" />
				<a-input v-model="goodInfo.name" allowClear class="a_input_self margin_self" placeholder="请输入品类名称" />
				<a-button type="primary" style="margin: 5px" @click="serchall"> 查询 </a-button>
			</a-row>

			<a-table :data-source="goodsLis" bordered rowKey="id" :row-selection="{ selectedRowKeys: selectedRowKeysFlow, onChange: onSelectChangeFlow, type: 'radio' }"
			 :pagination="paginationFlow" @change="handleTableChangeFlow">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ (pagination.current - 1) * 10 + index + 1 }}</template>
				</a-table-column>
				<a-table-column key="company_name" title="公司名称" data-index="company_name" />
				<a-table-column key="spu_sn" title="物品编号" data-index="spu_sn" />
				<a-table-column key="name" title="物品名称" data-index="name" />
				<a-table-column key="model" title="规格型号" data-index="model" />
				<a-table-column key="create_by" title="入库人" data-index="create_by" />
			</a-table>
		</a-modal>
		<!-- 详情 -->
		<a-modal title="详情" :visible="is_details" @cancel="details = false" width="70%">
			<a-form-model :model="detailsInfo" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="申请单号">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="申请部门">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="申请人">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="物品名称">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="物品类型">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="规格型号">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="申购数量">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="采购数量">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="单位">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="预估价">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="申请时间">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="期望交付时间">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="备注">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="采购价">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="供应商">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="采购人">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="采购时间">
							<a-input v-model="form.name"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>

		<!-- <purchaseDetails ref="purchaseDetails" /> -->
	</div>
</template>
<script>
	import debounce from 'lodash/debounce'
	import {
		selectBizPurchaseApplyList,
		updateBizGoodsInfoWarehousing,
		receipt_checkin3,
		tree_all
	} from '@/api/purchase'
	import {
		// sku_spu_get_list,
		dept_get
	} from '@/api/assetmenag'
	import {
		getDeptListEnable2
	} from '@/api/system'
	import {
		get_dict
	} from '@/utils/unit_axios'
	import uploadImg from '@/components/module/uploadImg'
	export default {
		data() {
			return {
				deptTree:[],
				serchInfo: {
					purchaseCode: '',
					createBy: '',
					company_id: undefined,
					deptId: undefined,
					createTimelist: [],
				},
				selectedRowKeys: [],
				fileData: {
					info: {
						type: 'pdf',
						asset_sn: '',
						dept_id: '',
					},
					name: 'file',
					types: ['application/pdf'],
				},
				fileDataFlow: {
					info: {
						type: 'pdf',
						asset_sn: '',
						dept_id: '',
					},
					name: 'file',
					types: ['application/pdf'],
				},
				plainOptions: ['易制毒', '易制爆', '剧毒', '其他'],
				plainOptions2: ['常温', '冷冻', '冷藏', '避光', '其他'],
				val: null,
				//固定验证
				rulesFixation: {
					order_id: [{
						required: true,
						message: '申请单号不能为空',
						trigger: 'blur'
					}],
					company_name: [{
						required: true,
						message: '公司名称不能为空',
						trigger: 'blur'
					}],
					asset_type: [{
						required: true,
						message: '资产类别不能为空',
						trigger: 'blur'
					}],
					asset_sn: [{
						required: true,
						message: '物品编号不能为空',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '物品名称不能为空',
						trigger: 'blur'
					}],
					model: [{
						required: true,
						message: '规格型号不能为空',
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: '物品状态不能为空',
						trigger: 'blur'
					}],
					is_inspected: [{
						required: true,
						message: '是否检定不能为空',
						trigger: 'blur'
					}],
					value: [{
						required: true,
						message: '当前估值不能为空',
						trigger: 'blur'
					}],
					keeper: [{
						required: true,
						message: '保管人不能为空',
						trigger: 'blur'
					}],
					operator: [{
						required: true,
						message: '入库人不能为空',
						trigger: 'blur'
					}],
					charger: [{
						required: true,
						message: '责任人不能为空',
						trigger: 'blur'
					}],
					dept_id: [{
						required: true,
						message: '责任部门不能为空',
						trigger: 'blur'
					}],
					purchase_time: [{
						required: true,
						message: '采购时间不能为空',
						trigger: 'blur'
					}],
					purchase_price: [{
						required: true,
						message: '采购总额不能为空',
						trigger: 'blur'
					}],
					amount: [{
						required: true,
						message: '入库数量不能为空',
						trigger: 'blur'
					}],
					unit: [{
						required: true,
						message: '物品单位不能为空',
						trigger: 'blur'
					}],
				},
				//流动验证
				rulesFlow: {
					order_id: [{
						required: true,
						message: '申请单号不能为空',
						trigger: 'blur'
					}],
					company_name: [{
						required: true,
						message: '公司名称不能为空',
						trigger: 'blur'
					}],
					asset_type: [{
						required: true,
						message: '资产类别不能为空',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '物品名称不能为空',
						trigger: 'blur'
					}],
					model: [{
						required: true,
						message: '规格型号不能为空',
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: '物品状态不能为空',
						trigger: 'blur'
					}],
					is_inspected: [{
						required: true,
						message: '是否检定不能为空',
						trigger: 'blur'
					}],
					cateModule: [{
						required: true,
						message: '请选择类',
						trigger: 'blur'
					}],
					value: [{
						required: true,
						message: '当前估值不能为空',
						trigger: 'blur'
					}],
					keeper: [{
						required: true,
						message: '保管人不能为空',
						trigger: 'blur'
					}],
					operator: [{
						required: true,
						message: '入库人不能为空',
						trigger: 'blur'
					}],
					charger: [{
						required: true,
						message: '责任人不能为空',
						trigger: 'blur'
					}],
					dept_id: [{
						required: true,
						message: '责任部门不能为空',
						trigger: 'blur'
					}],
					purchase_time: [{
						required: true,
						message: '采购时间不能为空',
						trigger: 'blur'
					}],
					purchase_price: [{
						required: true,
						message: '采购总额不能为空',
						trigger: 'blur'
					}],
					amount: [{
						required: true,
						message: '入库数量不能为空',
						trigger: 'blur'
					}],
					unit: [{
						required: true,
						message: '物品单位不能为空',
						trigger: 'blur'
					}],
				},
				statusMap: null,
				formdeptlist: [],
				companylist: [],
				deptlist: [],
				scroll_y: 150,
				loading: true,
				lis: [],
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				paginationFlow: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				labelCol: {
					span: 8,
				},
				wrapperCol: {
					span: 16,
				},
				is_fixation: false, //固定isshow
				form: {
					item_type: 1, //	整数	入库类型：固定传2
					order_id: '', //	整数	订单id
					orderCode: '',
					asset_sn: '', //	字符串	资产编号
					asset_type: undefined, //资产类别
					company_id: '', //公司id
					company_name: this.$store.state.user.info.company, //公司名称
					name: '', //	字符串	名称
					unit: '', //	字符串	单位
					state: undefined, //	整数	状态
					model: '', //	字符串	规格型号
					storage_loc: '', //	字符串	存放位置
					storage_cond: '', //	字符串	存放条件
					purchase_time: '', //	日期字符串	采购时间
					purchase_price: '', //	整数	采购价格*100
					dept_id: undefined, //	整数	部门id
					value: '', //	整数	估值*100
					amount: '',
					actualAmount: '',
					singlePrice: '',
					charger: '', //	字符串	责任人
					operator: this.$store.state.user.info.userName, //	字符串	入库人
					keeper: this.$store.state.user.info.userName, //	字符串	保管人
					arrive_time: '', //	日期字符串	到货日期
					dealer: '', //	字符串	供应商
					manufacturer: '', //	字符串	生产厂家
					factory_sn: '', //	字符串	出厂编号
					is_inspected: '0', //	布尔值	是否已检定
					inspect_cycle: '', //	字符串	检定周期
					inspect_time: '', //	日期字符串	检定日期
					precisions: '', //	字符串	精度
					inspect_result: '', //	字符串	检定结果
					permit: '', //	字符串	准用说明
					notes: '', //	字符串	备注
					att_path: '', //	字符串	附件地址，以；隔开
				},
				formFlow: {
					company_name: this.$store.state.user.info.company,
					item_type: 2, //	整数	入库类型：固定传1
					asset_type: undefined,
					order_id: '', //	字符串	订单id
					orderCode: '',
					spu_id: '', //	整数	耗材id
					factory_batch: '', //字符串	生产批次
					purchase_price: '', //	整数	采购价格*100
					operator: '', //	字符串	入库人
					name: '', //字符串	物品名称
					model: '', //字符串	规格型号
					state: undefined, //整数	物品状态
					stable_lmt: '', //	字符串	化学定值
					storage_loc: '', //字符串	存放位置
					is_inspected: undefined, //	布尔值	是否检定
					keeper: '', //	字符串	保管人
					dept_id: undefined, //整数	责任部门
					value: '', //	整数	采购总额*100
					purchase_amount: '', //	整数	采购数量*100
					unit: '', //	字符串	物品单位
					charger: '', //	字符串	责任人
					dealer: '', //	字符串	供应商
					amount: '', //	整数	入库数量*100
					manufacturer: '', //	字符串	生产厂家
					purchase_time: '', //日期字符串	采购时间
					arrive_time: '', //日期字符串	到货时间
					inspect_cycle: '', //字符串	检定周期
					inspect_time: '', //	日期字符串	检定日期
					inspect_result: '', //	字符串	检定结果
					notes: '', //	字符串	备注
					hazard_type: '',
					storage_cond: '',
					hazard_type_other: '',
					storage_cond_other: '',
				},
				is_flow: false, //流动isShow
				changevisible: false,
				goodInfo: {
					id: '',
					name: '',
					company_id: '',
				},
				goodsLis: [],
				selectedRowKeysFlow: [],
				selectval: {},
			}
		},
		components: {
			uploadImg
		},
		created() {
			get_dict('goodStatus', (res) => {
				console.log(res)
				this.statusMap = res
			})
		},
		mounted() {
			this.get_list()
			tree_all().then((res) => {
				this.companylist = res.data[0]
				this.companylist.unshift({
					deptId: 0,
					deptName: '所有公司',
					children: [],
				})
				this.companylist.forEach((item) => {
					if (item.title == this.form.company_name) {
						this.formdeptlist = item.children
						this.goodInfo.company_id = item.deptId
					}
				})
			})
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 120
				}, 1000)
			})
		},
		methods: {
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			amountchange(amount) {
				if (amount <= 0) {
					this.formFlow.amount = ''
				} else if (amount > this.formFlow.warehousingAmount) {
					this.formFlow.amount = this.formFlow.warehousingAmount
				}
			},
			//切换公司
			handlecompany(value) {
				this.deptTree=[]
				this.deptlist = []
				this.serchInfo.deptId = undefined
				this.$nextTick(() => {
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree, this.serchInfo.company_id)
						}
					})
				})
			},
			//选择单选
			onSelectChange(selectedRowKeys, val) {
				this.selectedRowKeys = selectedRowKeys
				this.val = val[0]
			},
			//设置上传变量
			setUploadInfo() {
				this.fileData = {
					info: {
						type: 'pdf',
						asset_sn: this.form.asset_sn,
						dept_id: this.form.dept_id,
					},
					name: 'file',
					types: ['application/pdf'],
				}
			},
			//设置上传变量流动
			setUploadInfoFlow(id) {
				this.fileDataFlow = {
					info: {
						type: 'pdf',
						asset_sn: '',
						dept_id: this.formFlow.dept_id,
					},
					name: 'file',
					types: ['application/pdf'],
				}
				dept_get(id).then(res=>{
					this.formFlow.charger=res.leader
				})
			},
			//获取上传的文件
			handleOk(data) {
				this.form.att_path = data.join(',')
			},
			handleOkFlow(data) {
				this.formFlow.att_path = data.join(',')
			},
			//提交固定资产入库
			sumbitFixation: debounce(function() {
				this.$refs.ruleFormFixation.validate((valid) => {
					if (valid) {
						this.form.purchase_price = this.form.singlePrice * 100
						this.form.singlePrice = this.form.purchase_price * 100
						this.form.value = this.form.value * 100
						delete this.form.amount
						receipt_checkin3(this.form).then((res) => {
							console.log(res)
							if (res.code != 200) {
								return this.$message.error(res.msg)
							}
							this.$message.success('提交成功')
							this.is_fixation = false
							this.set_good_status_fixed()
							this.get_list()
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			}, 1000, {
				'leading': true,
				'trailing': false
			}),

			// 详情
			show_details() {
				this.is_details = true
			},
			//重置
			reset() {
				this.serchInfo = {
					purchaseCode: '',
					createBy: '',
					company_id: undefined,
					deptId: undefined,
					createTimelist: [],
				}
			},
			//搜索
			serch_get_lis() {
				this.loading = true
				this.pagination.current = 1
				this.get_list()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.loading = true
				this.get_list()
			},
			//获取列表
			get_list() {
				selectBizPurchaseApplyList({
					old:1,
					pageNum: this.pagination.current,
					pageSize: this.pagination.pageSize,
					purchaseCode: this.serchInfo.purchaseCode,
					createBy: this.serchInfo.createBy,
					deptId: this.serchInfo.deptId,
					createTime1: this.serchInfo.createTimelist.length ? this.serchInfo.createTimelist[0] : '',
					createTime2: this.serchInfo.createTimelist.length ? this.serchInfo.createTimelist[1] : '',
				}).then((res) => {
					if (res.code == 200) {
						this.lis = res.rows
						const pagination = { ...this.pagination
						}
						pagination.total = res.total
						this.pagination = pagination
					} else {
						this.$message.error(res.msg)
					}
					this.loading = false
				})
			},
			//显示固定录入
			show_fixation() {
				this.form = {
					item_type: 1, //	整数	入库类型：固定传2
					order_id: this.val.id, //	整数	订单id
					asset_sn: '', //	字符串	资产编号
					asset_type: this.val.itemType, //资产类别
					company_id: '', //公司id
					company_name: this.$store.state.user.info.company, //公司名称
					name: this.val.applyName, //	字符串	名称
					unit: this.val.applyUnit, //	字符串	单位
					orderCode: this.val.purchaseCode,
					state: undefined, //	整数	状态
					model: this.val.applyModel, //	字符串	规格型号
					storage_loc: '', //	字符串	存放位置
					storage_cond: '', //	字符串	存放条件
					purchase_time: this.val.purchaseTime, //	日期字符串	采购时间
					purchase_price: this.val.purchasePrice, //	整数	采购价格*100
					amount: this.val.amount,
					warehousingAmount: this.val.warehousingAmount,
					actualAmount: this.val.actualAmount,
					singlePrice: Number(this.val.purchasePrice / this.val.actualAmount).toFixed(2),
					dept_id: undefined, //	整数	部门id
					value: this.val.price, //	整数	估值*100
					charger: '', //	字符串	责任人
					operator: this.$store.state.user.info.userName, //	字符串	入库人
					keeper: this.$store.state.user.info.userName, //	字符串	保管人
					arrive_time: this.val.arrivalDate, //	日期字符串	到货日期
					dealer: this.val.supplier, //	字符串	供应商
					manufacturer: '', //	字符串	生产厂家
					factory_sn: '', //	字符串	出厂编号
					is_inspected: '0', //	布尔值	是否已检定
					inspect_cycle: '', //	字符串	检定周期
					inspect_time: '', //	日期字符串	检定日期
					precisions: '', //	字符串	精度
					inspect_result: '', //	字符串	检定结果
					permit: '', //	字符串	准用说明
					notes: '', //	字符串	备注
					att_path: '', //	字符串	附件地址，以；隔开
				}
				this.is_fixation = true
			},
			//显示流动录入
			show_flow() {
				this.formFlow = {
					company_name: this.$store.state.user.info.company,
					item_type: 2, //	整数	入库类型：固定传1
					order_id: this.val.id, //	字符串	订单id
					spu_id: '', //	整数	耗材id
					factory_batch: '', //字符串	生产批次
					asset_type: this.val.itemType, //资产类别
					purchase_price: Number(this.val.purchasePrice / this.val.actualAmount).toFixed(2), //	整数	采购价格*100
					operator: this.$store.state.user.info.userName, //	字符串	入库人
					name: this.val.name, //字符串	物品名称
					orderCode: this.val.purchaseCode,
					model: this.val.model, //字符串	规格型号
					state: undefined, //整数	物品状态
					stable_lmt: '', //	字符串	化学定值
					storage_loc: '', //字符串	存放位置
					is_inspected: '0', //	布尔值	是否检定
					keeper: this.$store.state.user.info.userName, //	字符串	保管人
					dept_id: undefined, //整数	责任部门
					value: this.val.purchasePrice, //	整数	采购总额*100
					purchase_amount: this.val.actualAmount, //	整数	采购数量*100
					amountPlase: this.val.amount,
					warehousingAmount: this.val.warehousingAmount,
					unit: this.val.unit, //	字符串	物品单位
					charger: '', //	字符串	责任人
					dealer: this.val.supplier, //	字符串	供应商
					amount: '', //	整数	入库数量*100
					manufacturer: '', //	字符串	生产厂家
					purchase_time: this.val.purchaseTime, //日期字符串	采购时间
					arrive_time: '', //日期字符串	到货时间
					inspect_cycle: '', //字符串	检定周期
					inspect_time: '', //	日期字符串	检定日期
					inspect_result: '', //	字符串	检定结果
					notes: '', //	字符串	备注
					hazard_type: [],
					cateModule: '',
					storage_cond: [],
					hazard_type_other: '',
					storage_cond_other: '',
				}
				this.is_flow = true
			},
			//弹出物品列表
			show_all() {
				if (!this.formFlow.name) {
					this.$message.error('请先输入物品名称')
					return
				}
				this.changevisible = true
				this.goodInfo.name = this.formFlow.name
				this.sku_get()
			},
			//查找物品
			serchall() {
				this.pagination.current = 1
				this.sku_get()
			},
			//获取物品列表
			sku_get() {
				// sku_spu_get_list({
				// 	page_size: this.paginationFlow.pageSize,
				// 	page_num: this.paginationFlow.current,
				// 	name: this.goodInfo.name,
				// 	spu_sn: this.goodInfo.id,
				// 	company_id: this.goodInfo.company_id,
				// }).then((res) => {
				// 	const paginationFlow = { ...this.paginationFlow
				// 	}
				// 	paginationFlow.total = res.data.total
				// 	this.paginationFlow = paginationFlow
				// 	this.goodsLis = res.data.items
				// 	// this.goodsLis.forEach((item) => {
				// 	// 	item.price = item.price / 100
				// 	// 	item.value = item.value / 100
				// 	// 	item.amount = item.amount / 100
				// 	// })
				// })
			},
			//物品分页
			handleTableChangeFlow(pagination, filters, sorter) {
				this.paginationFlow.current = pagination.current
				this.paginationFlow.pageSize = pagination.pageSize
				this.sku_get()
			},
			//选中物品
			onSelectChangeFlow(selectedRowKeys, val) {
				this.selectedRowKeysFlow = selectedRowKeys
				this.formFlow.cateModule = val[0].name
				this.selectval = val[0]
			},
			selectRadioFlow() {
				this.formFlow.spu_id = this.selectedRowKeysFlow[0]
				if (this.selectval.unit) {
					this.formFlow.unit = this.selectval.unit
				}
				if (this.selectval.model) {
					this.formFlow.model = this.selectval.model
				}
				if (this.selectval.is_inspected != null) {
					this.formFlow.is_inspected = this.selectval.is_inspected + ''
				}
				if (this.selectval.notes) {
					this.formFlow.notes = this.selectval.notes
				}
				if (this.selectval.hazard_type) {
					this.formFlow.hazard_type = this.selectval.hazard_type
					if (this.selectval.hazard_type.indexOf('其他') != -1) {
						this.formFlow.hazard_type_other = this.selectval.hazard_type.split(';')[this.selectval.hazard_type.split(';').length -
							1]
					} else {
						this.formFlow.hazard_type_other = ''
					}
				} else {
					this.formFlow.hazard_type_other = ''
				}
				if (this.selectval.storage_cond) {
					this.formFlow.storage_cond = this.selectval.storage_cond
					if (this.selectval.storage_cond.indexOf('其他') != -1) {
						this.formFlow.storage_cond_other = this.selectval.storage_cond.split(';')[this.selectval.storage_cond.split(';').length -
							1]
					} else {
						this.formFlow.storage_cond_other = ''
					}
				} else {
					this.formFlow.storage_cond_other = ''
				}
				this.changevisible = false
			},
			//流动提交
			sumbitFLow: debounce(function() {
				this.$refs.ruleFormFlow.validate((valid) => {
					if (valid) {
						this.formFlow.purchase_price = this.formFlow.purchase_price * 100
						this.formFlow.value = this.formFlow.value * 100
						this.formFlow.purchase_amount = this.formFlow.purchase_amount * 100
						this.formFlow.amount = this.formFlow.amount * 100
						this.formFlow.name = this.formFlow.cateModule
						receipt_checkin3(this.formFlow).then((res) => {
							console.log(res)
							if (res.code != 200) {
								return this.$message.error(res.msg)
							}
							this.$message.success('提交成功')
							this.set_good_status()
							this.is_flow = false
							this.get_list()
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			}, 1000, {
				'leading': true,
				'trailing': false
			}),
			// 采购物品入库
			set_good_status() {
				updateBizGoodsInfoWarehousing([{
					isStorage: 1,
					id: this.val.goodsId,
					actualWarehousingAmount: this.formFlow.amount,
					warehousingAmount: this.formFlow.warehousingAmount
				}]).then((res) => {
					this.selectedRowKeys = []
					this.$forceUpdate()
				})
			},
			set_good_status_fixed() {
				updateBizGoodsInfoWarehousing([{
					isStorage: 1,
					id: this.val.goodsId,
					actualWarehousingAmount: 1,
					warehousingAmount: this.form.warehousingAmount
				}]).then((res) => {
					this.selectedRowKeys = []
					this.$forceUpdate()
				})
			},
		},
	}
</script>
<style scoped lang='less'>
	.ant-table td {
		white-space: nowrap;
	}
</style>
